import { render } from "./dialogSearchProduct.vue?vue&type=template&id=e74b137e&scoped=true"
import script from "./dialogSearchProduct.vue?vue&type=script&lang=js"
export * from "./dialogSearchProduct.vue?vue&type=script&lang=js"

import "./dialogSearchProduct.vue?vue&type=style&index=0&id=e74b137e&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e74b137e"]])

export default __exports__